export const COMPANY = {
  brand: "DeterShop",
  legalName: "Matris Malina PFA",
  cui: "55219998",
  regNo: "F2026035667007",
  phone: "0755664665",
  phoneTel: "tel:0755664665",
  email: "contact@detershop.ro",
  address: "România (adresa sediului se completează în panou / .env)",
};
